import { render, staticRenderFns } from "./CapturedImgsList.vue?vue&type=template&id=2dd29c25&scoped=true&"
import script from "./CapturedImgsList.vue?vue&type=script&lang=js&"
export * from "./CapturedImgsList.vue?vue&type=script&lang=js&"
import style0 from "./CapturedImgsList.vue?vue&type=style&index=0&id=2dd29c25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd29c25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dd29c25')) {
      api.createRecord('2dd29c25', component.options)
    } else {
      api.reload('2dd29c25', component.options)
    }
    module.hot.accept("./CapturedImgsList.vue?vue&type=template&id=2dd29c25&scoped=true&", function () {
      api.rerender('2dd29c25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Packages/Captures/components/CapturedImgsList.vue"
export default component.exports